/**
 * Switch node configuration type and validation
 */

export type SwitchCaseType = {
  value: string;
  label?: string;
};

export type SwitchConfigType = {
  expression: string;
  cases: SwitchCaseType[];
  defaultLabel?: string;
};

export const defaultSwitchConfig: SwitchConfigType = {
  expression: '',
  cases: [{ value: '', label: '' }],
  defaultLabel: 'Default',
};

/**
 * Validation: max 3 cases, unique values, non-empty values
 */
export const validateSwitchConfig = (
  config: SwitchConfigType,
): Record<string, string> => {
  const errors: Record<string, string> = {};

  if (!config.expression?.trim()) {
    errors.expression = 'Expression is required';
  }

  if (!config.cases || config.cases.length === 0) {
    errors.cases = 'At least one case is required';
  } else if (config.cases.length > 3) {
    errors.cases = 'Maximum 3 cases allowed';
  } else {
    const values = new Set<string>();
    for (let i = 0; i < config.cases.length; i++) {
      const c = config.cases[i];
      if (!c.value?.trim()) {
        errors[`case_${i}`] = 'Case value is required';
      } else if (values.has(c.value)) {
        errors[`case_${i}`] = 'Case values must be unique';
      } else {
        values.add(c.value);
      }
    }
  }

  return errors;
};

/**
 * Get preview text for the node display
 */
export const getSwitchPreviewText = (config: SwitchConfigType): string => {
  if (!config.expression) return 'Configure switch';
  const caseCount = config.cases?.length || 0;
  return `${caseCount} case${caseCount !== 1 ? 's' : ''} + default`;
};
